export default "__VITE_ASSET__D783Gbnj__"